import { render, staticRenderFns } from "./PropertyStats.vue?vue&type=template&id=5ec25386&scoped=true"
import script from "./PropertyStats.vue?vue&type=script&lang=js"
export * from "./PropertyStats.vue?vue&type=script&lang=js"
import style0 from "./PropertyStats.vue?vue&type=style&index=0&id=5ec25386&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec25386",
  null
  
)

export default component.exports